import React from 'react';

const DeviceContext = React.createContext();

export default DeviceContext;